enum CognitoSignUpFailureType {
    GENERIC = 'GENERIC',
    USERNAME_ALREADY_EXISTS = 'USERNAME_ALREADY_EXISTS',
}

export { CognitoSignUpFailureType };
